"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @description
 * 共通の画像用コンポーネント
 * 今後の実装で遅延ローディングなど加工予定なので、画像を使用する場合は基本的にこのコンポーネントを利用する。
 */
var Image = function (props) {
    return (0, jsx_runtime_1.jsx)("img", __assign({}, props));
};
exports.Image = Image;
